import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/(static)/about/components/background-animation-layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/(static)/about/components/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/(static)/about/components/hover-images/inject-hover-images.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/nextjs/app/(site)/(static)/about/components/section-title/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutPageContextProvider"] */ "/app/app/nextjs/app/(site)/(static)/about/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/(static)/about/sections/info/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/(static)/about/sections/news/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/(static)/about/sections/philosophies-and-values/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/(static)/about/sections/team/components/staff-grid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/(static)/about/sections/values/components/carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/context/ua-parser.ts");
